import React from 'react';
import Group from '@bubble-ui/primitive-group';
import Shape from '@bubble-ui/primitive-shape';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';

var FlagDK = function FlagDK() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Group, {
    id: "denmark"
  }, /*#__PURE__*/React.createElement(Shape, {
    id: "white",
    fill: "#FFF",
    d: "M0,90a90,90 0 1,0 180,0a90,90 0 1,0 -180,0"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M49.9999943,170.644802 C62.0495853,176.632938 75.6315827,180 90,180 C136.325539,180 174.47627,144.999507 179.450712,100 L179.450712,100 L50,100 L50,170.644805 L50,170.644805 L49.9999943,170.644802 L49.9999943,170.644802 L49.9999943,170.644802 Z M30,157.083197 C13.9223855,142.693343 3.04855005,122.608679 0.549287698,100 L30,100 L30,157.083197 L30,157.083197 L30,157.083197 L30,157.083197 L30,157.083197 Z M49.9999943,9.35519833 C62.0495852,3.36706168 75.6315827,0 90,0 C136.325539,0 174.47627,35.0004935 179.450712,80 L179.450712,80 L50,80 L50,9.35519552 L50,9.35519552 L49.9999943,9.35519833 L49.9999943,9.35519833 L49.9999943,9.35519833 Z M30,22.916803 C13.9223855,37.3066571 3.04855005,57.3913208 0.549287698,80 L30,80 L30,22.916803 L30,22.916803 L30,22.916803 L30,22.916803 L30,22.916803 Z",
    id: "red",
    fill: "#E94B35"
  })));
};

FlagDK.displayName = 'FlagDK';
export default withFlagWrapper(FlagDK);
//# sourceMappingURL=index.js.map